import { SummaryFeatureList } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const DefaultIndividualsFeatureList: SummaryFeatureList = [
  'create_limit',
  'unlimited_questions',
  'response_count',
  'support',
  'quizzes_pro',
  'analyze_export_enabled',
  'skip_logic',
  'statistical_significance',
];

export default DefaultIndividualsFeatureList;
